<template>
  <div
    class="inbox-body"
    v-loading="loading"
    element-loading-text="Fetching sent messages..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.8)"
  >
    <div class="header">
      <h2>Sent</h2>
      <div class="pagination">
        <span>{{ paginationText }}</span>
        <button @click="prevPage" :disabled="!canGoBack">❮</button>
        <button @click="nextPage" :disabled="!canGoForward">❯</button>
      </div>
    </div>
    <app-messages :messages="sentMessages"></app-messages>
  </div>
</template>

<script>
  import Messages from './messages.vue';
  import { fetchMessagesByType } from './data/messages'; // Same API logic as inbox.vue

  export default {
    props: {
      mailConfiguration: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        sentMessages: [],
        totalMessages: 0,
        pageSize: 15,
        currentPage: 1,
        nextPageToken: null,
        prevPageTokens: [],
        loading: false,
      };
    },
    created() {
      this.getMessages();
    },
    methods: {
      async getMessages(pageToken = null) {
        try {
          this.loading = true;
          let data = await fetchMessagesByType(
            this.mailConfiguration.service,
            this.mailConfiguration.user._id,
            'sent', // indicate sent folder or type
            this.pageSize,
            pageToken
          );
          if (data?.emails?.length > 0) {
            this.totalMessages = Math.max(
              this.totalMessages || 0,
              (this.currentPage - 1) * this.pageSize + data?.emails?.length
            );
          }

          this.nextPageToken = data.nextPageToken;
          this.$set(this, 'sentMessages', data.emails);
        } catch (error) {
          console.error('Failed to fetch sent messages:', error);
        } finally {
          this.loading = false;
        }
      },
      nextPage() {
        if (this.nextPageToken) {
          this.prevPageTokens.push(this.nextPageToken);
          this.currentPage++;
          this.getMessages(this.nextPageToken);
        }
      },
      prevPage() {
        if (this.prevPageTokens.length > 1) {
          this.currentPage--;
          const prevToken = this.prevPageTokens[this.prevPageTokens.length - 2];
          this.prevPageTokens.pop();
          this.getMessages(prevToken);
        } else {
          this.currentPage = 1;
          this.getMessages(null);
        }
      },
    },
    computed: {
      paginationText() {
        let start = (this.currentPage - 1) * this.pageSize + 1;
        let end = this.currentPage * this.pageSize;
        if (!this.nextPageToken) {
          end = Math.min(end, this.totalMessages);
        }
        return `${start}-${end} of ${this.totalMessages || 'Many'} `;
      },
      canGoBack() {
        return this.prevPageTokens.length > 0;
      },
      canGoForward() {
        return !!this.nextPageToken;
      },
    },
    components: {
      appMessages: Messages,
    },
  };
</script>

<style scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
  }
  .pagination {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
  }
  button {
    padding: 5px 10px;
    border: none;
    background-color: #007bff;
    color: white;
    cursor: pointer;
    border-radius: 5px;
  }
  button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
</style>
